import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { showSuccess, showWarning } from "@/utils/UI";
import DuduAjax from "@/utils/DuduAjax";
import { API_BIS_DATA_SYNC_SUBMIT } from "@/configs/Apis";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataSync',
  emits: ["query"],
  setup(__props, { expose, emit }) {


const store = useStore();

const visible = ref(false);
const loading = ref(false);

const projectId = computed(() => (store.state as any).project.info.id);

const expr = ref("");
const helpVisible = ref(false);
const helpTab = ref("examples");

const samples = [
  { label: "申请人+名称+日期", expr: "(Samsung Electronics).AP. AND (Display).TI. AND @AD>=20200101" },
  { label: "分类+关键词", expr: "(Battery and control*).KEY. AND (H01M*).CPC. AND (KR).APC." },
  { label: "申请人+摘要+公开日", expr: "(Nvidia).AP. AND (AI and accelerat*).AB. AND @PD>=20000101<=20251231" },
  { label: "关键词+优先权国", expr: "(Robot and arm).AB. AND (US).PRC." },
];

const applySample = (sampleExpr: string) => {
  expr.value = sampleExpr;
};

const open = (initialExpr?: string) => {
  if (!isEmptyOrWhiteSpace(initialExpr)) {
    expr.value = initialExpr as string;
  }
  visible.value = true;
};

const closeDialog = () => {
  visible.value = false;
};

const searchData = async () => {
  if (isEmptyOrWhiteSpace(expr.value)) {
    showWarning("请填写检索式");
    return;
  }
  try {
    loading.value = true;
    const res: any = await DuduAjax.post(API_BIS_DATA_SYNC_SUBMIT, {
      projectId: projectId.value,
      wipsQueryString: expr.value,
    });

    store.dispatch("synctask/progressDataSync", {
      projectId: projectId.value,
      taskId: res.requestUuid,
    });
    showSuccess("提交成功，请在任务列表中查看同步的任务");
    closeDialog();
  } finally {
    loading.value = false;
  }
};

const navToGlobalSearch = () => {
  window.open("http://bis.quan-ip.com/sso.html");
};

expose({ open });

return { __sfc: true,emit, store, visible, loading, projectId, expr, helpVisible, helpTab, samples, applySample, open, closeDialog, searchData, navToGlobalSearch }
}

})